import * as React from 'react'

export default ({ width = 18, height = 16 }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5 6.5C7.48528 6.5 9.5 8.51472 9.5 11V16.5H0.5V11C0.5 8.51472 2.51472 6.5 5 6.5Z"
        fill="black"
        stroke="white"
      />
      <circle cx="5" cy="4" r="3.5" fill="black" stroke="white" />
      <path
        d="M15 6.5C17.4853 6.5 19.5 8.51472 19.5 11V16.5H10.5V11C10.5 8.51472 12.5147 6.5 15 6.5Z"
        fill="black"
        stroke="white"
      />
      <circle cx="15" cy="4" r="3.5" fill="black" stroke="white" />
      <path
        d="M10 9.5C12.4853 9.5 14.5 11.5147 14.5 14V19.5H5.5V14C5.5 11.5147 7.51472 9.5 10 9.5Z"
        fill="black"
        stroke="white"
      />
      <circle cx="10" cy="7" r="3.5" fill="black" stroke="white" />
    </svg>
  )
}
